import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Image from 'next/image';
import { anime } from 'react-anime';

const NextImage = ({ className, animate, animationDuration, ...props }) => {
	const ref = useRef(null);
	const [isVisible, setIsVisible] = useState(props.priority ?? false);

	useEffect(() => {
		if (isVisible && animate) {
			anime({
				targets: ref.current,
				opacity: 1,
				duration: animationDuration,
				easing: 'linear'
			});
		}
	}, [isVisible, animate]);

	return (
		<div className={className} ref={ref} style={{ opacity: animate ? 0 : 1 }}>
			<Image onLoad={() => setIsVisible(true)} {...props} />
		</div>
	);
};

NextImage.propTypes = {
	className: PropTypes.string,
	animate: PropTypes.bool,
	priority: PropTypes.bool,
	animationDuration: PropTypes.number
};

NextImage.defaultProps = {
	animate: true,
	animationDuration: 300
};

export default NextImage;
